export class QuickbooksCompany {
  id = -1;
  name = "";
  ready = false;
  needs_reauth = false;
  errors = [];
  edition = "";
  track_classes_by = "disabled" as "disabled" | "invoice" | "line_item";
  item_income_account_name = "";
  payment_deposit_account_name = "";
  refund_credit_account_name = "";

  constructor(params: Partial<QuickbooksCompany> = {}) {
    Object.assign(this, params);
  }
}

export class AccountType {
  field_name = "";
  field_label = "";
  tooltip_text = "";

  constructor(params: Partial<AccountType> = {}) {
    Object.assign(this, params);
  }
}

export class AccountingClassStatusDetail {
  icon = "";
  tooltip = "";

  constructor(params: Partial<AccountingClassStatusDetail> = {}) {
    Object.assign(this, params);
  }
}
